// component/FiltrerTransactionModal.js
import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  ButtonGroup,
} from "reactstrap";
import '../utils/detail.css';
const FiltrerTransactionModal = ({ isOpen, toggle, onApply, paymentMethods = [] }) => {
  const [status, setStatus] = useState("");
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
const [createdAtFrom, setCreatedAtFrom] = useState("");
const [createdAtTo, setCreatedAtTo] = useState("");
  const [useAmountInterval, setUseAmountInterval] = useState(false);
  const [minAmount, setMinAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");

  const applyFilters = () => {
    onApply({
      status,
       paymentMethods: selectedPaymentMethod,
      createdAtFrom,
      createdAtTo,
      minAmount: minAmount !== "" ? parseFloat(minAmount) : null,
      maxAmount: maxAmount !== "" ? parseFloat(maxAmount) : null,
    });
    toggle();
  };

  return (
    <Modal
  isOpen={isOpen}
  toggle={toggle}
  contentClassName="custom-filter-modal"
>

      <ModalHeader toggle={toggle} className="custom-modal-header"style={{color:'#000000'}}>
        Filtrer
      </ModalHeader>
      <ModalBody>
    <div className="mb-3">
   <div className="d-flex align-items-center me-3">
    <label className=" mb-0 me-2 lanel">Statut</label>
    <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
  </div>
  <ButtonGroup>
   <Button
  style={{
    backgroundColor: status === "" ? "#3761FF14" : "#0000000F",
    color: status === "" ? "#3761FF" : "#000000",
    border:status===""? "1px solid #3761FF14": "1px solid #0000000F",
    fontWeight: status === "" ? 500 : 400,
    margin: "10px",
    borderRadius: "6px",
    fontSize:'14px'
  }}
  onClick={() => setStatus("")}
>
  Tous
</Button>

    <Button
     style={{
        backgroundColor: status === "SUCCESS" ? "#EBFFEA" : "#0000000F",
        color: status === "SUCCESS" ? "#349C32" : "#000000",
        border:status==="SUCCESS"? "1px solid #EBFFEA": "1px solid #0000000F",
        fontWeight: status === "SUCCESS" ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
        fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setStatus("SUCCESS")}
    >
      Réussie
    </Button>
    <Button
     style={{
        backgroundColor: status === "REJECTED" ? "#FFF0F0" : "#0000000F",
        color: status === "REJECTED" ? "#E32727" : "#000000",
        border:status==="REJECTED"? "1px solid #FFF0F0": "1px solid #0000000F",
        fontWeight: status === "REJECTED" ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
         fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setStatus("REJECTED")}
    >
      Echouée
    </Button>
    <Button
     style={{
        backgroundColor: status === "PENDING" ? "#FFFBE6" : "#0000000F",
        color: status === "PENDING" ? "#AD8B00" : "#000000",
        border:status==="PENDING"? "1px solid #FFF0F0": "1px solid #0000000F",
        fontWeight: status === "PENDING" ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
         fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setStatus("PENDING")}
    >
      En cours
    </Button>
  </ButtonGroup>
  </div>
   <div className="mb-3">
   <div className="d-flex align-items-center me-3">
    <label className=" mb-0 me-2 lanel">Opérateur</label>
    <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
  </div>
    <FormGroup className="col-4">
  <Input
  style={{margin:"10px"}}
    type="select"
    value={selectedPaymentMethod}
    onChange={(e) => setSelectedPaymentMethod(e.target.value)}
  >
    <option value="">Toutes</option>
    {paymentMethods.map((method, index) => (
      <option key={index} value={method}>
        {method}
      </option>
    ))}
  </Input>
</FormGroup>
    </div>
       <div className="mb-3">
  <div className="d-flex align-items-center me-3">
    <label className="mb-0 me-2 lanel">Date</label>
    <div style={{ width: "100%", border: "1px solid #0000001A" }}></div>
  </div>

  <div className="d-flex gap-2" style={{ margin: "10px" }}>
    <Input
      type="date"
      value={createdAtFrom}
      onChange={(e) => setCreatedAtFrom(e.target.value)}
    />

    <Input
      type="date"
      value={createdAtTo}
      onChange={(e) => setCreatedAtTo(e.target.value)}
    />
  </div>
</div>
          <div className="mb-3">
  <div className="d-flex align-items-center me-3 mb-2">
    <label className="mb-0 me-2 lanel">Montant</label>
    <div style={{ width: "100%", border: '1px solid #0000001A' }}></div>
  </div>

  <FormGroup check className="mb-2">
    <Input
      type="radio"
      name="amountFilter"
      id="amountAll"
      checked={!useAmountInterval}
      onChange={() => setUseAmountInterval(false)}
    />
    <Label check for="amountAll"className="lanel">Tous</Label>
  </FormGroup>

  <FormGroup check className="mb-3">
    <Input
      type="radio"
      name="amountFilter"
      id="amountInterval"
      checked={useAmountInterval}
      onChange={() => setUseAmountInterval(true)}
    />
    <Label check for="amountInterval "className="lanel">Intervalle de chiffre (XOF)</Label>
  </FormGroup>

  {useAmountInterval && (
    <div className="d-flex gap-3">
      <FormGroup className="w-50">
        <Label className="lanel">Montant min</Label>
        <Input
          type="number"
          value={minAmount}
          onChange={(e) => setMinAmount(e.target.value)}
        />
      </FormGroup>
      <FormGroup className="w-50">
        <Label className="lanel">Montant max</Label>
        <Input
          type="number"
          value={maxAmount}
          onChange={(e) => setMaxAmount(e.target.value)}
        />
      </FormGroup>
    </div>
  )}
    </div>
    <Button
    className="button apply-filter-btn"
   
    onClick={applyFilters}
  >
    Appliquer le filtre
  </Button>
      </ModalBody>
    </Modal>
  );
};

export default FiltrerTransactionModal;
